import { r4Client, r4Error } from "@/services";

const R4UtilsApi = {
  // const exampleCopyDirectiveInput = {
  //   from: 'https://d2fi4ri5dhpqd1.cloudfront.net/public/resources/social-networks-icon-sets/t-only-logo-dark-gray/facebook@2x.png',
  //   to: {
  //     bucket: 'r4-cimg-dev',
  //     key: 'f730a5a2-ffdc-4f42-803d-e5c7f771aa8e/facebook@2x.png',
  //     href: 'https://r4-cimg-dev.s3.amazonaws.com/r4-cimg-dev/f730a5a2-ffdc-4f42-803d-e5c7f771aa8e/facebook@2x.png'
  //   }
  // }
  async copyUrlToS3(copyDirectives) {
    try {
      const resp = await r4Client().post('/api/v1/utils/s3/copy_url_to_s3', {
        copy_directives: copyDirectives
      })
      return resp.data
    } catch (error) {
      throw r4Error(error)
    }
  },

  openHtmlInNewTab: (html) => {
    const winUrl = URL.createObjectURL(new Blob([html], { type: 'text/html' }))
    const tab = window.open(winUrl, '_blank')
    tab.focus()
  }
}

export default R4UtilsApi
